import GoogleApiError from '../../models/gapi/gapiError';

/**
 * @param onAuthorizationExpired What to do about a 401. Must be
 * gapiCtx.authorizationExpired, not logout: an access token lasts an hour
 * and a tab asleep past the renewal meets one this way, so revoking here
 * spent the user's consent on the most ordinary event there is - and made
 * the next sign-in a fresh consent screen. authorizationExpired renews
 * through the refresh token first and says something only if that fails,
 * which is why nothing is said here.
 */
export default function handleGapiError(
  callSnackbar: (message: any) => void,
  onAuthorizationExpired: () => void,
) {
  return function (err: any, defaultMessage?: string) {
    if (err.result && err.result.error) {
      const gapiErr = err.result as GoogleApiError;

      if (gapiErr.error.code === 401) {
        onAuthorizationExpired();
      } else if (
        gapiErr.error.code === 403 &&
        gapiErr.error.errors.some(
          (x) => x.reason === 'appNotAuthorizedToFile' || x.reason === 'insufficientScopes',
        )
      ) {
        callSnackbar(
          'You have not granted the app enough access. Please modify the apps permissions.',
        );
      } else if (
        gapiErr.error.code === 403 &&
        gapiErr.error.errors.some((x) => x.reason === 'domainPolicy')
      ) {
        callSnackbar('The domain administrators have disabled Drive apps.');
      } else if (
        gapiErr.error.code === 403 &&
        gapiErr.error.errors.some((x) => x.reason === 'insufficientFilePermissions')
      ) {
        callSnackbar('You do not have sufficient permissions for this file.');
      } else if (gapiErr.error.code === 404) {
        callSnackbar('Unable to find requested resource!');
      } else if (gapiErr.error.code === 403 || gapiErr.error.code === 429) {
        callSnackbar('GoogleDrive requests rate limited!');
      } else if (gapiErr.error.code >= 500) {
        callSnackbar('GoogleDrive server error! Please try again later.');
      } else {
        callSnackbar(defaultMessage || gapiErr.error.message);
      }
      // gapi.auth2 error
    } else if (err.error && err.details) {
      callSnackbar(err.details);
      // Catch all
    } else {
      callSnackbar(defaultMessage || err);
    }
  };
}
